export const GET_EMPLOYEES = Symbol('GET_EMPLOYEES');
export const GET_EMPLOYEES_REQUEST = Symbol('GET_EMPLOYEES_REQUEST');
export const GET_EMPLOYEES_SUCCESS = Symbol('GET_EMPLOYEES_SUCCESS');
export const GET_EMPLOYEES_ERROR = Symbol('GET_EMPLOYEES_ERROR');

